import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

export interface Props {
  classNames?: string[]
  children?: React.ReactNode
  width?: number | string
  computedWidth?: string
  align?: 'left' | 'center' | 'right'
  firstCell?: boolean
  lastCell?: boolean
  strong?: boolean
  minor?: boolean
  error?: boolean
  warning?: boolean
  subRow?: boolean
  noBorder?: boolean
}

const TableCell = ({
  classNames,
  children,
  computedWidth: width,
  align = 'left',
  firstCell = false,
  lastCell = false,
  strong = false,
  minor = false,
  warning = false,
  error = false,
  subRow = false,
  noBorder = false,
}: Props) => {
  const containerProps = {
    className: cn(
      'TableCell',
      {
        [`align-${align}`]: !!align,
        fixed: !!width && width.includes('px'),
        firstCell,
        lastCell,
        strong,
        minor,
        warning,
        error,
        subRow,
        noBorder,
      },
      classNames
    ),
    style: {width},
  }

  return (
    <div {...containerProps}>
      <div className="TableCell__content">{children}</div>
    </div>
  )
}

export default TableCell
